import { gql } from 'generated-types/gql';

export default gql(`
mutation saveSingleConfiguration($configuration: ConfigurationInput!) {
  saveSingleConfiguration(configuration: $configuration) {
    _id
    confirmationNum
    overwriteRequired
  }
}
`);
